<div class="dashboard-hero">
  <div class="container">
    <div class="hero-content">
      <h1 class="hero-title">
        <i class="bi bi-journal-text hero-icon"></i>
        Article Staging
      </h1>
      <p class="hero-subtitle">Import and review new articles and their DXF files for inclusion in BPSolver.</p>
    </div>
  </div>
</div>

<div class="container dashboard-container">
  <div class="row" #ArticleStagingHeader>

  <app-uploads></app-uploads>
  
  <!-- Error Message Display -->
  <div class="row" *ngIf="displayError" #ArticlesErrorViewer>
    <div class="alert alert-warning" role="alert">
      {{errorMessage}}
    </div>
  </div>

  <div class="row" #ArticlesTable>
    <form (keydown.enter)="$event.preventDefault()" class="w-100">
      <div class="modern-card mb-4">
        <div class="modern-card-header">
          <div class="card-title-wrapper">
            <i class="bi bi-journal-richtext card-icon"></i>
            <h5 class="modern-card-title">Systems & Articles</h5>
          </div>
        </div>
        <div class="modern-card-body">
          <div class="search-filter-row">
            <!-- Search input -->
            <div class="search-field-wrapper">
              <label for="table-filtering-search" class="article-search-label">
                <i class="bi bi-search"></i> Full text search:
              </label>
              <input id="table-filtering-search" placeholder="Search by system name, article name…"
                class="form-control search-input" type="text" name="searchTerm"
                [(ngModel)]="articleService.searchTerm" (keydown.enter)="search($event)" />
            </div>

            <!-- Filter button with active tags -->
            <div class="filter-field-wrapper" (keydown.enter)="$event.preventDefault()">
              <label class="article-search-label"><i class="bi bi-funnel-fill"></i> Filter:</label>
              <div class="filter-controls">
                <span ngbDropdown (keydown.enter)="$event.preventDefault()">
                  <button class="btn btn-filter-modern" ngbDropdownToggle (keydown.enter)="$event.preventDefault()">
                    <i class="bi bi-funnel-fill"></i> Filter
                  </button>
                  <ul ngbDropdownMenu (keydown.enter)="$event.preventDefault()">
                    <li class="dropdown-item" *ngFor="let filter of filterOptions">
                      <input type="checkbox" [checked]="filter.selected" (change)="onFilterChange(filter, $event)" />
                      {{filter.label}}
                    </li>
                  </ul>
                </span>
                <span class="d-flex flex-wrap gap-1">
                  <span class="filter-tag" *ngFor="let filter of getSelectedFilters()">
                    {{ filter.label }}
                    <span (click)="removeFilter(filter)" aria-label="Close" class="filter-tag-close">&#x2715;</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="loading" class="loader-overlay">
        <div class="spinner-border text-primary"></div>
      </div>
      <div class="modern-table-wrapper mb-4">
      <table *ngIf="searchResults.length" class="modern-outer-table w-100">
        <tbody>
          <ng-container class="system-row" *ngFor="let result of searchResults">
            <tr>
              <td colspan="1" (click)="result.showApplicationTable = !result.showApplicationTable"
                class="application-name-row">
                <i class="bi bi-chevron-right row-prefix-icon" *ngIf="!result.showApplicationTable"></i>
                <i class="bi bi-chevron-down row-prefix-icon" *ngIf="result.showApplicationTable"></i>
                {{result.application}}
              </td>
            </tr>
            <table class="app-tree-table" *ngIf="result.showApplicationTable">
              <tbody>
                <ng-container class="system-row" *ngFor="let system of result.systemNames">
                  <tr>
                    <td colspan="1" class="system-name-row">
                      <div style="float:left;width:80%;"
                        (click)="result.showApplicationTable = !result.showApplicationTable">
                        <i class="bi bi-chevron-right row-prefix-icon" *ngIf="!result.showApplicationTable"></i>
                        <i class="bi bi-chevron-down row-prefix-icon" *ngIf="result.showApplicationTable"></i>
                        {{system.systemName}} <span>(Total articles:{{system.articles?.length}})</span>
                      </div>
                      <div class="right-aligned-buttons">
                        <div class="btn-group">
                          <button type="button" class="btn-modern-action btn-action-primary"
                            (click)="exportToExcel(system.systemName)" (keydown.enter)="$event.preventDefault()">
                            <i class="bi bi-file-earmark-excel"></i> Export
                          </button>
                        </div>
                        <div class="btn-group" ngbDropdown>
                          <button type="button" class="btn-modern-action btn-action-secondary"
                            id="dropdownBasic2" ngbDropdownToggle>
                            <i class="bi bi-download"></i> Download
                          </button>
                          <ul ngbDropdownMenu class="dropdown-menu" *ngIf="isBPSApp(result.application)">
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="downloadArticleImages(system.systemName)">Download Article
                              <!-- (click)="downloadArticleImages(system.articles, system.systemName)">Download Article -->
                              Images</button>
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="downloadThreeJsFiles(system.systemName)">Download 3JS
                              files</button>
                          </ul>
                        </div>
                        <div class="btn-group" ngbDropdown>
                          <button type="button" class="btn-modern-action btn-action-primary" id="dropdownBasic1" ngbDropdownToggle>
                            <i class="bi bi-gear-fill"></i> Actions
                          </button>
                          <ul ngbDropdownMenu class="dropdown-menu" *ngIf="isBPSApp(result.application)">
                            <button ngbDropdownItem (keydown.enter)="$event.preventDefault()"
                              (click)="pushSystem(system.systemName, 'BPS_DEV')">Push to BPS Dev</button>
                            <button ngbDropdownItem (keydown.enter)="$event.preventDefault()"
                              (click)="pushSystem(system.systemName, 'BPS_Staging')"> Push to BPS Staging</button>
                            <button ngbDropdownItem (keydown.enter)="$event.preventDefault()"
                              (click)="pushSystem(system.systemName, 'BPS_Production')"> Push to BPS Production</button>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr *ngIf="system.articles?.length">
                    <td colspan="1" style="padding: 0 0.75rem 0.75rem">
                      <div class="article-table-scroll-wrapper">
                        <table class="modern-table">
                    <thead>
                      <tr>
                        <th scope="col">Article</th>
                        <th scope="col">Country</th>
                        <th scope="col">Inside Width</th>
                        <th scope="col">Outside Width</th>
                        <th scope="col">Depth</th>
                        <th scope="col">Profile Type</th>
                        <th scope="col">Sectional Properties</th>
                        <!-- <th scope="col">sLogic</th> -->
                        <th scope="col">Image</th>
                        <th scope="col">3JS File</th>
                        <th scope="col">Model</th>
                        <th scope="col">DXF</th>
                        <th scope="col">Deployed To</th>
                        <th scope="col">Last Uploaded Time</th>
                        <th scope="col">Log</th>
                        <!-- <th scope="col">BPS Staging</th>
                        <th scope="col">BPS Production</th> -->
                        <th scope="col">Delete</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr valign="middle" *ngFor="let article of system.articles; index as i" [ngClass]="'my_class2'">
                        <!-- <tr valign="middle" *ngFor="let article of system.articles; index as i" [ngClass]="article.isArticleJSHasReview? 'row-highlighter' : 'my_class2'"></tr> -->
                        <!-- <th scope="row">{{article.articleName}}</th> -->
                        <td>{{article.ArticleName}}</td>
                        <td>{{article.country?.toString()}}</td>
                        <td>{{article.InsideW?.toString()}}</td>
                        <td>{{article.OutsideW?.toString()}}</td>
                        <td>{{article.Depth?.toString()}}</td>
                        <td>{{article.ProfileType}}</td>
                        <!-- <td><a class="image-link-button" *ngIf="article.isArticleSec == true" (click)="openSectionalPropertiesModal(sectionalPropertiesModal, article)">Properties</a></td>
                        <td><a class="image-link-button" *ngIf="article.isFacadeArticleSec == true" (click)="openSectionalPropertiesModal(facadeSectionalPropertiesModal, article)">Properties</a></td> -->
                        <td>
                          <a class="image-link-button" *ngIf="article.isArticleSec || article.isFacadeArticleSec"
                            (click)="openSectionalPropertiesModal(article.isArticleSec ? sectionalPropertiesModal : facadeSectionalPropertiesModal, article)">
                            Properties
                          </a>
                        </td>
                        <!-- <td><a class="image-link-button" (click)="opensLogicModal(sLogicModal, article)">sLogic</a></td> -->
                        <td><a class="image-link-button" (click)="openImageViewerModal(imageModal, article)">Image</a>
                        </td>
                        <!-- <td><a class="image-link-button" (click)="openDxfImageViewerModal(dxfImageModal, article)">Image</a></td> -->
                        <td>
                          <!-- <a href="{{article.ThreeJSFileStoragePath}}">
                            <img src="/assets/icons/download-24.png" />
                          </a> -->
                          <a href="#" (click)="openThreeJs(article, $event)">
                            <img src="/assets/icons/download-24.png" alt="Download" />
                          </a>
                        </td>
                        <!--                        <td><a class="image-link-button" (click)="openJsViewerModal(threeJsModal, article)">Model</a>-->
                        <td><a class="image-link-button" (click)="navigateToArticleViewer([article])">Model</a>

                          <!-- <td><a class="image-link-button" (click)="openSectionalPropertiesModal(sectionalPropertiesModal, article)">Properties</a></td> -->

                          <span class="model-status-marker status-ok" *ngIf="article.ThreeJSFileStoragePath">&#10003;</span>
                          <span class="model-status-marker status-missing" *ngIf="!article.ThreeJSFileStoragePath">&#10007;</span>
                        </td>
                        <td>
                          <!-- <a href="{{article.DxfStoragePath}}">
                            <img src="/assets/icons/download-24.png" />
                          </a> -->
                          <a href="#" (click)="openDxf(article, $event)">
                            <img src="/assets/icons/download-24.png" alt="Download" />
                          </a>
                        </td>
                        <td>
                          <span *ngIf="article.isBPSDevDeployed" class="deploy-badge deploy-dev">DEV</span>
                          <span *ngIf="article.isBPSStagingDeployed" class="deploy-badge deploy-staging">STAGING</span>
                          <span *ngIf="article.isBPSProdDeployed" class="deploy-badge deploy-prod">PROD</span>
                        </td>
                        <!-- <td><span
                            [ngClass]="article.isBPSStagingDeployed? 'text-success border border-success rounded' : 'text-secondary'">{{article.isBPSStagingDeployed
                            ? 'Deployed': 'Not'}}</span></td>
                        <td><span
                            [ngClass]="article.isBPSProdDeployed? 'text-success border border-success rounded' : 'text-secondary'">{{article.isBPSProdDeployed
                            ? 'Deployed': 'Not'}}</span></td> -->
                        <td>{{article.updatedFormattedDate}}</td>
                        <td><img class="image-link-button" *ngIf="article.exceptionMessage"
                            src="/assets/icons/exclamation-mark.png"
                            (click)="openExceptionModal(exceptionMessageModal, article)"></td>
                        <td>
                          <button class="btn-icon-danger" (click)="deleteArticle(article)"><img
                              src="/assets/icons/delete-24.png" /></button>
                        </td>
                        <td>
                          <div ngbDropdown container="body">
                            <button type="button" class="btn-modern-action btn-action-secondary" id="dropdownBasic1"
                              ngbDropdownToggle>
                              <i class="bi bi-gear-fill"></i> Actions
                            </button>
                            <ul ngbDropdownMenu class="dropdown-menu actions-scrollable-menu">
                              <ng-container *ngIf="isBPSApp(result.application)">
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'BPS_DEV', system.SystemName)">Push to BPS Dev</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'BPS_Staging', system.SystemName)">Push to BPS
                                  Staging</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'BPS_Production', system.SystemName)">Push to BPS
                                  Production</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="verifiedArticleByDesigner(article)">Verified By Designer</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="verifiedArticleByEngineer(article)">Verified By Engineer</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="issuesIdentifiedByDesigner(article)">Designer Identified Issues</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="issuesIdentifiedByEngineer(article)">Engineer Identified Issues</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="openDxfImport(dxfImportModal)">Reupload DXF</button>

                              </ng-container>
                              <!-- <hr class="dropdown-divider"> -->
                              <ng-container *ngIf="isSRSApp(result.Application)">
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'SRS_Dev', system.SystemName)">Push to SRS Dev</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'SRS_Staging', system.SystemName)">Push to SRS
                                  Staging</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem [disabled]=true
                                  (click)="pushArticle(article, 'BPS_Production', system.SystemName)">SRS
                                  Production</button>
                              </ng-container>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </tbody>
      </table>
      </div>
      <div class="modern-table-wrapper mb-4">
      <table *ngIf="!searchResults.length" class="modern-outer-table w-100">
        <tbody>
          <ng-container class="system-row" *ngFor="let application of applicationSystemArticleMap">
            <tr>
              <td colspan="1" (click)="application.showApplicationTable = !application.showApplicationTable"
                class="application-name-row">
                <i class="bi bi-chevron-right row-prefix-icon" *ngIf="!application.showApplicationTable"></i>
                <i class="bi bi-chevron-down row-prefix-icon" *ngIf="application.showApplicationTable"></i>
                {{application.Application}}
              </td>
            </tr>
            <table class="app-tree-table" *ngIf="application.showApplicationTable">
              <tbody>
                <ng-container class="system-row" *ngFor="let system of application.SystemNames">
                  <tr>
                    <td colspan="1" class="system-name-row">
                      <div style="float:left;width:100%;">
                        <div (click)="loadArticles(system.SystemName)" style="display: inline-block; cursor: pointer;">
                          <i class="bi bi-chevron-right row-prefix-icon"
                            *ngIf="!loadedArticles[system.SystemName]?.showTable"></i>
                          <i class="bi bi-chevron-down row-prefix-icon"
                            *ngIf="loadedArticles[system.SystemName]?.showTable"></i>
                          {{system.SystemName}}
                          <span>
                            (Total articles:{{system.ArticleCount}})
                          </span>
                          <i class="bi bi-play-btn row-prefix-icon" *ngIf="loadedArticles[system.SystemName]?.showTable"
                            (click)="navigateToArticleViewer(articlesSectionBySystem)"></i>
                        </div>
                      </div>
                      <div class="right-aligned-buttons">
                        <div class="btn-group">
                          <button type="button" class="btn-modern-action btn-action-primary"
                            (click)="exportToExcel(system.SystemName)" (keydown.enter)="$event.preventDefault()">
                            <i class="bi bi-file-earmark-excel"></i> Export
                          </button>
                        </div>
                        <div class="btn-group" ngbDropdown>
                          <button type="button" class="btn-modern-action btn-action-secondary"
                            id="dropdownBasic2" ngbDropdownToggle>
                            <i class="bi bi-download"></i> Download
                          </button>
                          <ul ngbDropdownMenu class="dropdown-menu" *ngIf="isBPSApp(application.Application)">
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="downloadArticleImages(system.SystemName)">Download Article Images</button>
                            <!-- (click)="downloadArticleImages(loadedArticles[system.SystemName].articles, system.SystemName)">Download Article Images</button> -->
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="downloadThreeJsFiles(system.SystemName)">Download 3JS files</button>
                          </ul>
                        </div>
                        <div class="btn-group" ngbDropdown>
                          <button type="button" class="btn-modern-action btn-action-primary" id="dropdownBasic1" ngbDropdownToggle>
                            <i class="bi bi-gear-fill"></i> Actions
                          </button>
                          <ul ngbDropdownMenu class="dropdown-menu" *ngIf="isBPSApp(application.Application)">
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="pushSystem(system.SystemName, 'BPS_DEV')">Push to BPS Dev</button>
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="pushSystem(system.SystemName, 'BPS_Staging')">Push to BPS Staging</button>
                            <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                              (click)="pushSystem(system.SystemName, 'BPS_Production')">Push to BPS Production</button>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr *ngIf="loadedArticles[system.SystemName]?.showTable">
                    <td colspan="1" style="padding: 0 0.75rem 0.75rem">
                      <div class="article-table-scroll-wrapper">
                        <table class="modern-table">
                    <thead>
                      <tr>
                        <th scope="col">Article</th>
                        <th scope="col">Country</th>
                        <th scope="col">Inside Width</th>
                        <th scope="col">Outside Width</th>
                        <th scope="col">Depth</th>
                        <th scope="col">Profile Type</th>
                        <th scope="col">Sectional Properties</th>
                        <!-- <th scope="col">sLogic</th> -->
                        <th scope="col">Image</th>
                        <th scope="col">3JS File</th>
                        <th scope="col">Model</th>
                        <th scope="col">DXF</th>
                        <th scope="col">Deployed To</th>
                        <th scope="col">Last Uploaded Time</th>
                        <th scope="col">Log</th>
                        <!-- <th scope="col">BPS Staging</th>
                        <th scope="col">BPS Production</th> -->
                        <th scope="col">Delete</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr valign="middle"
                        *ngFor="let article of loadedArticles[system.SystemName]?.articles; index as i"
                        [ngClass]="'my_class2'">
                        <!-- <tr valign="middle" *ngFor="let article of loadedArticles[system]?.articles; index as i" [ngClass]="article.isArticleJSHasReview? 'row-highlighter' : 'my_class2'"></tr> -->
                        <!-- <th scope="row">{{article.articleName}}</th> -->
                        <td>{{article.ArticleName}}</td>
                        <td>{{article.country?.toString()}}</td>
                        <td>{{article.InsideW?.toString()}}</td>
                        <td>{{article.OutsideW?.toString()}}</td>
                        <td>{{article.Depth?.toString()}}</td>
                        <td>{{article.ProfileType}}</td>
                        <!-- <td><a class="image-link-button" *ngIf="article.isArticleSec == true" (click)="openSectionalPropertiesModal(sectionalPropertiesModal, article)">Properties</a></td>
                        <td><a class="image-link-button" *ngIf="article.isFacadeArticleSec == true" (click)="openSectionalPropertiesModal(facadeSectionalPropertiesModal, article)">Properties</a></td> -->
                        <td>
                          <a class="image-link-button" *ngIf="article.isArticleSec || article.isFacadeArticleSec"
                            (click)="openSectionalPropertiesModal(article.isArticleSec ? sectionalPropertiesModal : facadeSectionalPropertiesModal, article)">
                            Properties
                          </a>
                        </td>
                        <!-- <td><a class="image-link-button" (click)="opensLogicModal(sLogicModal, article)">sLogic</a></td> -->
                        <td><a class="image-link-button" (click)="openImageViewerModal(imageModal, article)">Image</a>
                        </td>
                        <td>
                          <!-- <a href="{{article.ThreeJSFileStoragePath}}">
                            <img src="/assets/icons/download-24.png" />
                          </a> -->
                          <a href="#" (click)="openThreeJs(article, $event)">
                            <img src="/assets/icons/download-24.png" alt="Download" />
                          </a>
                        </td>
                        <!--                        <td><a class="image-link-button" (click)="openJsViewerModal(threeJsModal, article)">Model</a>-->
                        <td><a class="image-link-button" (click)="navigateToArticleViewer([article])">Model</a>

                          <!-- <td><a class="image-link-button" (click)="openSectionalPropertiesModal(sectionalPropertiesModal, article)">Properties</a></td> -->

                          <span class="model-status-marker status-ok" *ngIf="!!article.ThreeJSFileStoragePath">&#10003;</span>
                          <span class="model-status-marker status-missing" *ngIf="!article.ThreeJSFileStoragePath">&#10007;</span>
                        </td>
                        <td>
                          <!-- <a href="{{article.DxfStoragePath}}">
                            <img src="/assets/icons/download-24.png" />
                          </a> -->
                          <a href="#" (click)="openDxf(article, $event)">
                            <img src="/assets/icons/download-24.png" alt="Download" />
                          </a>
                        </td>
                        <td>
                          <span *ngIf="article.isBPSDevDeployed" class="deploy-badge deploy-dev">DEV</span>
                          <span *ngIf="article.isBPSStagingDeployed" class="deploy-badge deploy-staging">STAGING</span>
                          <span *ngIf="article.isBPSProdDeployed" class="deploy-badge deploy-prod">PROD</span>
                        </td>
                        <!-- <td><span
                            [ngClass]="article.isBPSStagingDeployed? 'text-success border border-success rounded' : 'text-secondary'">{{article.isBPSStagingDeployed
                            ? 'Deployed': 'Not'}}</span></td>
                        <td><span
                            [ngClass]="article.isBPSProdDeployed? 'text-success border border-success rounded' : 'text-secondary'">{{article.isBPSProdDeployed
                            ? 'Deployed': 'Not'}}</span></td>-->
                        <td>{{article.updatedFormattedDate}}</td>
                        <td><img class="image-link-button" *ngIf="article.exceptionMessage"
                            src="/assets/icons/exclamation-mark.png"
                            (click)="openExceptionModal(exceptionMessageModal, article)"></td>
                        <td>
                          <button class="btn-icon-danger" (click)="deleteArticle(article)"><img
                              src="/assets/icons/delete-24.png" /></button>
                        </td>
                        <td>
                          <div ngbDropdown container="body">
                            <button type="button" class="btn-modern-action btn-action-secondary" id="dropdownBasic1"
                              ngbDropdownToggle>
                              <i class="bi bi-gear-fill"></i> Actions
                            </button>
                            <ul ngbDropdownMenu class="dropdown-menu actions-scrollable-menu">
                              <ng-container *ngIf="isBPSApp(application.Application)">
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'BPS_DEV', system.SystemName)">Push to BPS Dev</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'BPS_Staging', system.SystemName)">Push to BPS
                                  Staging</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'BPS_Production', system.SystemName)">Push to BPS
                                  Production</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="verifiedArticleByDesigner(article)">Verified By Designer</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="verifiedArticleByEngineer(article)">Verified By Engineer</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="issuesIdentifiedByDesigner(article)">Designer Identified Issues</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="issuesIdentifiedByEngineer(article)">Engineer Identified Issues</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="openDxfImport(dxfImportModal)">Reupload DXF</button>
                              </ng-container>
                              <!-- <hr class="dropdown-divider"> -->
                              <ng-container *ngIf="isSRSApp(application.Application)">
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'SRS_Dev', system.SystemName)">Push to SRS Dev</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem
                                  (click)="pushArticle(article, 'SRS_Staging', system.SystemName)">Push to SRS
                                  Staging</button>
                                <button (keydown.enter)="$event.preventDefault()" ngbDropdownItem [disabled]=true
                                  (click)="pushArticle(article, 'BPS_Production', system.SystemName)">Push to SRS
                                  Production</button>
                              </ng-container>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </tbody>
      </table>
      </div>
    </form>
  </div>
</div>

<ng-template #imageModal let-modal>
  <div class="modal-header modal-modern-header">
    <div class="modal-title-wrapper">
      <i class="bi bi-image modal-header-icon"></i>
      <h5 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}} — Article Image</h5>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body modal-modern-body modal-image-body">
    <div class="modal-image-wrapper">
      <img *ngIf="modalContentPresignedUrl" [src]="modalContentPresignedUrl"
        alt="The article image from this article's DXF file" class="article-image img-fluid">
      <div *ngIf="!modalContentPresignedUrl" class="modal-image-placeholder">
        <i class="bi bi-image-fill modal-image-placeholder-icon"></i>
        <span>No image available</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dxfImageModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <app-dxf-viewer class="model-viewer-wrapper" articleName="modalContent?.ArticleName"
      articleDxf="{{modalContent?.DxfStoragePath}}">
    </app-dxf-viewer>
  </div>
</ng-template>

<ng-template #sLogicModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" style="height: 800px;">
    <iframe src="https://article-data-files-dev.s3.amazonaws.com/540870.txt" width=100% height=100% frameborder=0
      id="frame"></iframe>

    <!-- {{modalContent | json}} -->
  </div>
</ng-template>

<ng-template #pdf let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" style="height: 800px;">
    <a href="https://article-data-files-dev.s3.amazonaws.com/540870-3D.pdf" target="_blank"
      download="540870-3D.pdf">Download PDF</a>
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false"
      style="width: 100%; height: 100%"></pdf-viewer>
    <!-- {{modalContent | json}} -->
  </div>
</ng-template>

<ng-template #sectionalPropertiesModal let-modal>
  <div class="modal-header modal-modern-header">
    <div class="modal-title-wrapper">
      <i class="bi bi-bar-chart-steps modal-header-icon"></i>
      <h5 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}} — Sectional Properties</h5>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body modal-modern-body">
    <div class="modal-table-scroll-wrapper">
      <table class="modal-modern-table">
        <thead>
          <tr>
            <th>Article</th>
            <th>Inside Width</th>
            <th>Outside Width</th>
            <th>Left Rebate</th>
            <th>Right Rebate</th>
            <th>Distance Between Bars</th>
            <th>D</th>
            <th>Weight</th>
            <th>AO</th>
            <th>AU</th>
            <th>IO</th>
            <th>IU</th>
            <th>IOYY</th>
            <th>IUYY</th>
            <th>ZOO</th>
            <th>ZOU</th>
            <th>ZOL</th>
            <th>ZOR</th>
            <th>ZUO</th>
            <th>ZUU</th>
            <th>ZUL</th>
            <th>ZUR</th>
            <th>RSN20</th>
            <th>RSP80</th>
            <th>CN20</th>
            <th>CP20</th>
            <th>CP80</th>
            <th>Beta</th>
            <th>A2</th>
            <th>E</th>
            <th>Alpha</th>
            <th>WOYP</th>
            <th>WOYN</th>
            <th>WOZN</th>
            <th>WUYP</th>
            <th>WUYN</th>
            <th>WUZP</th>
            <th>WUZN</th>
            <th>Depth</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{modalContent?.ArticleName}}</td>
            <td>{{modalContent?.InsideW}}</td>
            <td>{{modalContent?.OutsideW}}</td>
            <td>{{modalContent?.LeftRebate}}</td>
            <td>{{modalContent?.RightRebate}}</td>
            <td>{{modalContent?.DistBetweenIsoBars}}</td>
            <td>{{modalContent?.d | number:'1.2-2'}}</td>
            <td>{{modalContent?.Weight | number:'1.2-2'}}</td>
            <td>{{modalContent?.Ao | number:'1.2-2'}}</td>
            <td>{{modalContent?.Au | number:'1.2-2'}}</td>
            <td>{{modalContent?.Io | number:'1.2-2'}}</td>
            <td>{{modalContent?.Iu | number:'1.2-2'}}</td>
            <td>{{modalContent?.Ioyy | number:'1.2-2'}}</td>
            <td>{{modalContent?.Iuyy | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zoo | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zou | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zol | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zor | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zuo | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zuu | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zul | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zur | number:'1.2-2'}}</td>
            <td>{{modalContent?.RSn20}}</td>
            <td>{{modalContent?.RSp80}}</td>
            <td>{{modalContent?.Cn20}}</td>
            <td>{{modalContent?.Cp20}}</td>
            <td>{{modalContent?.Cp80}}</td>
            <td>{{modalContent?.beta}}</td>
            <td>{{modalContent?.A2}}</td>
            <td>{{modalContent?.E}}</td>
            <td>{{modalContent?.alpha}}</td>
            <td>{{modalContent?.Woyp | number:'1.2-2'}}</td>
            <td>{{modalContent?.Woyn | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wozn | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wuyp | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wuyn | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wuzp | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wuzn | number:'1.2-2'}}</td>
            <td>{{modalContent?.Depth}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #facadeSectionalPropertiesModal let-modal>
  <div class="modal-header modal-modern-header">
    <div class="modal-title-wrapper">
      <i class="bi bi-layout-three-columns modal-header-icon"></i>
      <h5 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}} — Facade Sectional Properties</h5>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body modal-modern-body">
    <div class="modal-table-scroll-wrapper">
      <table class="modal-modern-table">
        <thead>
          <tr>
            <th>Article</th>
            <th>Width</th>
            <th>BTDepth</th>
            <th>Weight</th>
            <th>ZO</th>
            <th>ZU</th>
            <th>ZL</th>
            <th>ZR</th>
            <th>A</th>
            <th>Material</th>
            <th>IYY</th>
            <th>IZZ</th>
            <th>WYY</th>
            <th>WZZ</th>
            <th>ASY</th>
            <th>ASZ</th>
            <th>J</th>
            <th>G</th>
            <th>EA</th>
            <th>GASY</th>
            <th>GASZ</th>
            <th>EIY</th>
            <th>EIZ</th>
            <th>GJ</th>
            <th>YS</th>
            <th>ZS</th>
            <th>RY</th>
            <th>RZ</th>
            <th>WYP</th>
            <th>WYN</th>
            <th>WZP</th>
            <th>WZN</th>
            <th>CW</th>
            <th>Beta Torsion</th>
            <th>ZY</th>
            <th>ZZ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{modalContent?.ArticleName}}</td>
            <td>{{modalContent?.Width}}</td>
            <td>{{modalContent?.BTDepth}}</td>
            <td>{{modalContent?.Weight | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zo | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zu | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zl | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zr | number:'1.2-2'}}</td>
            <td>{{modalContent?.A | number:'1.2-2'}}</td>
            <td>{{modalContent?.Material}}</td>
            <td>{{modalContent?.Iyy | number:'1.2-2'}}</td>
            <td>{{modalContent?.Izz | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wyy | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wzz | number:'1.2-2'}}</td>
            <td>{{modalContent?.Asy | number:'1.2-2'}}</td>
            <td>{{modalContent?.Asz | number:'1.2-2'}}</td>
            <td>{{modalContent?.J | number:'1.2-2'}}</td>
            <td>{{modalContent?.G | number:'1.2-2'}}</td>
            <td>{{modalContent?.EA | number:'1.2-2'}}</td>
            <td>{{modalContent?.GAsy | number:'1.2-2'}}</td>
            <td>{{modalContent?.GAsz | number:'1.2-2'}}</td>
            <td>{{modalContent?.EIy | number:'1.2-2'}}</td>
            <td>{{modalContent?.EIz | number:'1.2-2'}}</td>
            <td>{{modalContent?.GJ | number:'1.2-2'}}</td>
            <td>{{modalContent?.Ys | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zs | number:'1.2-2'}}</td>
            <td>{{modalContent?.Ry | number:'1.2-2'}}</td>
            <td>{{modalContent?.Rz | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wyp | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wyn | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wzp | number:'1.2-2'}}</td>
            <td>{{modalContent?.Wzn | number:'1.2-2'}}</td>
            <td>{{modalContent?.Cw | number:'1.2-2'}}</td>
            <td>{{modalContent?.Beta_torsion | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zy | number:'1.2-2'}}</td>
            <td>{{modalContent?.Zz | number:'1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #threeJsModal let-modal class="modal-fullscreen">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissJsModal(modal)"></button>
  </div>
  <div class="modal-body">
    <app-model-viewer *ngIf="jsUrl" class="model-viewer-wrapper" [imageUrl]="modalContent?.ImageStoragePath || ''"
      [jsUrl]="jsUrl" [articleName]="modalContent?.ArticleName || ''">
    </app-model-viewer>
  </div>
</ng-template>

<ng-template #tableEmpty>
  <tbody>
    <tr>
      <td>
        No articles found.
      </td>
    </tr>
  </tbody>
</ng-template>

<ng-template #dxfImportModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload DXF File(s)</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <app-dxf-import (close)="modal.dismiss('Uploaded DXF file(s)')"></app-dxf-import>
</ng-template>

<ng-template #exceptionMessageModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{modalContent?.ArticleName}} Exception Log</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" [innerHTML]="sanitizeExceptionMessage(modalContent?.exceptionMessage)"></div>
</ng-template>
